module.exports = __webpack_public_path__ + "img/noCart.6f2abfef.png";